<template>
  <mobile-reset-password v-if="isMobile" />
  <desktop-reset-password v-else />
</template>

<script>
  import { isMobile } from 'mobile-device-detect'
  import MobileResetPassword from '../../mobile/login/ResetPassword'
  import DesktopResetPassword from '../../desktop/login/ResetPassword'

  export default {
    name: 'common-reset-password',
    components: {
      'mobile-reset-password': MobileResetPassword,
      'desktop-reset-password': DesktopResetPassword
    },
    data () {
      return {
        isMobile
      }
    }
  }
</script>
